/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The TrustCommercesubscriptionPlansSubscriptionPlan model module.
 * @module model/TrustCommercesubscriptionPlansSubscriptionPlan
 * @version v0.3
 */
export default class TrustCommercesubscriptionPlansSubscriptionPlan {
  /**
   * Constructs a new <code>TrustCommercesubscriptionPlansSubscriptionPlan</code>.
   * @alias module:model/TrustCommercesubscriptionPlansSubscriptionPlan
   * @class
   * @param interval {module:model/TrustCommercesubscriptionPlansSubscriptionPlan.IntervalEnum} The frequency at which the customer is billed. Can be either 'day', 'week', 'month, or 'year'.
   * @param intervalCount {Number} The number of intervals (specified in the interval attribute) between billing periods. Must be between 1 and 99. For example, interval=month and interval_count=3 bills every 3 months.
   * @param amountCents {Number} The amount (in cents) that will be charged each billing period.
   */
  constructor(interval, intervalCount, amountCents) {
    this.interval = interval;
    this.intervalCount = intervalCount;
    this.amountCents = amountCents;
  }

  /**
   * Constructs a <code>TrustCommercesubscriptionPlansSubscriptionPlan</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/TrustCommercesubscriptionPlansSubscriptionPlan} obj Optional instance to populate.
   * @return {module:model/TrustCommercesubscriptionPlansSubscriptionPlan} The populated <code>TrustCommercesubscriptionPlansSubscriptionPlan</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new TrustCommercesubscriptionPlansSubscriptionPlan();
      if (data.hasOwnProperty('name'))
        obj.name = ApiClient.convertToType(data['name'], 'String');
      if (data.hasOwnProperty('interval'))
        obj.interval = ApiClient.convertToType(data['interval'], 'String');
      if (data.hasOwnProperty('interval_count'))
        obj.intervalCount = ApiClient.convertToType(data['interval_count'], 'Number');
      if (data.hasOwnProperty('amount_cents'))
        obj.amountCents = ApiClient.convertToType(data['amount_cents'], 'Number');
      if (data.hasOwnProperty('initial_payment_amount_cents'))
        obj.initialPaymentAmountCents = ApiClient.convertToType(data['initial_payment_amount_cents'], 'Number');
      if (data.hasOwnProperty('free_trial_period_days'))
        obj.freeTrialPeriodDays = ApiClient.convertToType(data['free_trial_period_days'], 'Number');
      if (data.hasOwnProperty('number_of_billing_periods'))
        obj.numberOfBillingPeriods = ApiClient.convertToType(data['number_of_billing_periods'], 'Number');
    }
    return obj;
  }
}

/**
 * Name of the subscription plan
 * @member {String} name
 */
TrustCommercesubscriptionPlansSubscriptionPlan.prototype.name = undefined;

/**
 * Allowed values for the <code>interval</code> property.
 * @enum {String}
 * @readonly
 */
TrustCommercesubscriptionPlansSubscriptionPlan.IntervalEnum = {
  /**
   * value: "day"
   * @const
   */
  day: "day",

  /**
   * value: "week"
   * @const
   */
  week: "week",

  /**
   * value: "month"
   * @const
   */
  month: "month",

  /**
   * value: "year"
   * @const
   */
  year: "year"
};
/**
 * The frequency at which the customer is billed. Can be either 'day', 'week', 'month, or 'year'.
 * @member {module:model/TrustCommercesubscriptionPlansSubscriptionPlan.IntervalEnum} interval
 */
TrustCommercesubscriptionPlansSubscriptionPlan.prototype.interval = undefined;

/**
 * The number of intervals (specified in the interval attribute) between billing periods. Must be between 1 and 99. For example, interval=month and interval_count=3 bills every 3 months.
 * @member {Number} intervalCount
 */
TrustCommercesubscriptionPlansSubscriptionPlan.prototype.intervalCount = undefined;

/**
 * The amount (in cents) that will be charged each billing period.
 * @member {Number} amountCents
 */
TrustCommercesubscriptionPlansSubscriptionPlan.prototype.amountCents = undefined;

/**
 * The amount (in cents) that will be charged on the first billing period only. Mustbe at least $1.00.
 * @member {Number} initialPaymentAmountCents
 */
TrustCommercesubscriptionPlansSubscriptionPlan.prototype.initialPaymentAmountCents = undefined;

/**
 * The number of days before the first billing period starts.
 * @member {Number} freeTrialPeriodDays
 */
TrustCommercesubscriptionPlansSubscriptionPlan.prototype.freeTrialPeriodDays = undefined;

/**
 * The number of times the customer will be billed. Leave as null for indefinite billing.
 * @member {Number} numberOfBillingPeriods
 */
TrustCommercesubscriptionPlansSubscriptionPlan.prototype.numberOfBillingPeriods = undefined;

